import { DefaultTheme } from "styled-components";

const PlaystoreTheme: DefaultTheme = {
};

export { PlaystoreTheme };